import type { WidgetParams, WidgetPermission } from '@common/types/content.type';

export const defaultWidgetPermission: WidgetPermission = {
    isReleased: true,
};

export const defaultWidgetParams: WidgetParams = {
    hasSetting: true,
    deletable: true,
    hidden: false,
    disabled: false,
    isEducation: false,
    showControls: true,
    type: ['default'],
};
